<template>
  <div>
    <VerticalMedias :medias="medias"
                    :loading="loading"
                    :paginate="paginate"
                    :isPaid="isPaid"
                    :digitalItemId="digitalItemId"
                    :gallery="gallery"
                    @nextPage="$emit('nextPage')"
                    @select="$emit('select', $event)"
                    v-if="gallery.layout===galleryLayouts.VERTICAL"/>

    <HorizontalMedias :medias="medias"
                      :loading="loading"
                      :paginate="paginate"
                      :isPaid="isPaid"
                      :digitalItemId="digitalItemId"
                      :gallery="gallery"
                      @nextPage="$emit('nextPage')"
                      @select="$emit('select', $event)"
                      v-if="gallery.layout===galleryLayouts.HORIZONTAL"/>
  </div>
</template>

<script>
import VerticalMedias from "@/domain/media/galleries/layouts/VerticalMedias.vue";
import {galleryLayouts} from "@/domain/media/galleries/constants";
import HorizontalMedias from "@/domain/media/galleries/layouts/HorizontalMedias.vue";


export default {
  name: 'MediasLayout',
  components: {HorizontalMedias, VerticalMedias},
  emits: ['nextPage', 'select'],
  props: {
    medias: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    paginate: {
      type: Boolean,
      required: true,
    },
    isPaid: {
      type: Boolean,
      required: false
    },
    digitalItemId: {
      type: Number,
      required: false
    },
    gallery: {
      type: Object,
      required: true
    }
  },
  computed: {
    galleryLayouts() {
      return galleryLayouts
    }
  }
}
</script>


<style scoped>

</style>